import { Outlet } from "react-router-dom";
import SideMenu from "../components/SideMenu";

export default function MainLayout() {
  return (
    <>
      {/* HEADER */}
      <div className="header">
        <img 
          src="/logt.png" 
          className="logo" 
          alt="App Logo"   /* warning fix */
        />

        <div className="searchBox">
          <input
            type="text"
            placeholder="Search movies, shows..."
          />
          <span>🔍</span>
        </div>
      </div>

      {/* SIDE MENU */}
      <SideMenu />

      {/* PAGE CONTENT */}
      <div className="pageContent">
        <Outlet />   {/* IMPORTANT */}
      </div>
    </>
  );
}
